import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {getAboutUsContent} from '@/content/aboutUs'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'

type ProfileBioProps = {
  bio: string[]
  education: string[]
  licenses?: string[]
}

export const ProfileBio: FC<ProfileBioProps> = ({bio, education, licenses}) => {
  const {t} = useTranslation()
  const {aboutTitle, educationTitle, licensesTitle} = getAboutUsContent().profilePage

  const profile = [
    {title: aboutTitle, content: bio},
    {title: educationTitle, content: education},
    ...(licenses ? [{title: licensesTitle, content: licenses}] : []),
  ]

  return (
    <>
      <div className="about">
        {profile.map(({title, content}, index) => (
          <div key={index} className="section">
            <Text variant={TextVariant.h4} element="h2">
              {t(title)}
            </Text>
            {content?.map((description, index) => (
              <Text key={index} variant={TextVariant.text20}>
                {t(description)}
              </Text>
            ))}
          </div>
        ))}
      </div>

      <style jsx>{`
        .about {
          margin: 0 ${theme.spacing[6]};
          max-width: calc(100% - 350px - ${theme.spacing[6]} * 2);
        }
        .section {
          display: flex;
          flex-direction: column;
          gap: ${theme.spacing[3]};
        }
        .section + .section {
          margin-top: ${theme.spacing[6]};
        }
        @media ${TABLET_SCREENSIZE} {
          .about {
            max-width: inherit;
          }
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .about {
            margin: 0 ${theme.spacing[5]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .about {
            margin: 0;
          }
        }
      `}</style>
    </>
  )
}
